/************
 * Developed by : Shiva Software Solutions
 * Date : 07-07-2025
 * Descriptions : Route page for TC Report Page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/

import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const tcUSerReportConfig = [
  {
    auth: authRole.amazonReportUser,
    routes: [
      {
        path: '/amazonPanel',
        component: React.lazy(() => import('./tcUserReport')),
      },
    ],
  },
];